import React, {Fragment} from 'react'

import Promo from '../promo'
import Banner from '../banner'

const BlogOther = ({item,condenseTop,condenseBottom}) => {
	switch(item.type){
		case 'promo': return <Promo {...item.primary} condenseTop={condenseTop} condenseBottom={condenseBottom} />;
		case 'banner': return <Banner {...item.primary} condenseTop={condenseTop} condenseBottom={condenseBottom} />;
	}
	return null;
}

export default BlogOther;